"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class TDateCell
 * @description  format a cell of type date with either relative or long format,
 *  also handle empty or error invalid states
 */
var React = require("react");
var dateUtil_1 = require("../../utils/dateUtil");
var types_1 = require("./types");
var useLocale_1 = require("../../hooks/useLocale");
var TDateCell = function (_a) {
    var value = _a.value, type = _a.type, props = __rest(_a, ["value", "type"]);
    var dateType = type === types_1.DataCellTypes.RelativeDate ? dateUtil_1.DateType.Relative : dateUtil_1.DateType.Full;
    var locale = useLocale_1.default();
    var formattedDate = dateUtil_1.formatDate(value, locale, dateType);
    return React.createElement("td", __assign({}, props), formattedDate);
};
exports.default = TDateCell;
//# sourceMappingURL=TDateCell.js.map